module.exports = __webpack_public_path__ + "static/media/027.e03686b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/027.jpg
// module id = 500
// module chunks = 0